import React, { useState } from 'react';
import PropTypes from 'prop-types';
import groupBy from 'lodash/groupBy';
import map from 'lodash/map';
import { HorizontalFlex } from 'smartsuite-ui';
import Station from './Station';

export default function Timeline(props) {
    const nodesGroupedByStation = groupBy(props.bagTimeLine, 'stationCode');

    return (
        <div className="timeline">
            {map(nodesGroupedByStation, (stationNodes, stationCode) => (
                <Station
                    key={stationCode}
                    isSelectedStation={
                        stationCode === props.selectedStationCode
                    }
                    nodes={stationNodes}
                    onStationClick={() => props.onStationClick(stationCode)}
                    stationCode={stationCode}
                />
            ))}
        </div>
    );
}

Timeline.propTypes = {
    selectedStationCode: PropTypes.string.isRequired,
    bagTimeLine: PropTypes.instanceOf(Array),
};
